import { Box, Autocomplete, TextField, InputAdornment } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

const SearchBar = ({ testCasesList, handleSearch }) => (
  <Box className='testCasesListSearchContainer'>
    <Autocomplete
      className='testCasesListSearch'
      freeSolo
      onChange={handleSearch}
      options={testCasesList}
      getOptionLabel={(testCase) => testCase?.name || ''}
      getOptionKey={testCase => testCase.id}
      filterOptions={(options, { inputValue }) =>
        options.filter(
          (option) =>
            option.name.toLowerCase().includes(inputValue.toLowerCase())
        )
      }
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          className='testCasesListSearchInput'
          variant="standard"
          placeholder='Search...'
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  </Box>
)

export default SearchBar